import { render, staticRenderFns } from "./PermGrant.vue?vue&type=template&id=4241aba0&scoped=true&"
import script from "./PermGrant.vue?vue&type=script&lang=ts&"
export * from "./PermGrant.vue?vue&type=script&lang=ts&"
import style0 from "./PermGrant.vue?vue&type=style&index=0&id=4241aba0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241aba0",
  null
  
)

export default component.exports